import { IcFocus } from '@assets/icons/24x24';
import { Icon, IconButton } from '@chakra-ui/react';

import { useGPSCoordinatesFieldContext } from './GPSCoordinatesFieldContext';

export const PositionPicker = () => {
  const { isSelectionEnabled, setSelectionOn } = useGPSCoordinatesFieldContext();

  return (
    <IconButton
      variant="pick"
      aria-label="positionPicker"
      data-active={isSelectionEnabled}
      onClick={() => setSelectionOn!(!isSelectionEnabled)}
    >
      <Icon as={IcFocus} boxSize="24px" />
    </IconButton>
  );
};
